import { useState, useEffect } from "react";

/**
 * Custom hook to manage the state with debounce time
 *
 * @param initialVal Initial value of the state
 * @param time Debounce time in milliseconds
 *
 * @returns Debounced state and dispatcher and instant search value
 *
 * @author Rajkumar Rathod
 */
export const useDebounce = <T extends string>(
  initialVal: T,
  time: number = 300 //default time in ms
): [string, (v: string) => void, string] => {
  const [search, setSearch] = useState<string>(initialVal ?? "");
  const [instantValue, setInstantValue] = useState<string>(initialVal ?? "");

  useEffect(() => {
    // setter after time delayed
    const setter = setTimeout(() => setSearch(instantValue), time);

    //clear setter timer
    return () => clearTimeout(setter);
  }, [instantValue, time]);

  /**
   * Dispatcher for search State
   * manage debounceState for delayed
   */
  const disPatcher = (val: string) => setInstantValue(val);

  /**
   * 1. search - debounce state
   * 2. dispatcher - to modify the search
   * 3. debouncedValue  instant search value
   */
  return [search, disPatcher, instantValue];
};
